import { Box, Button, CircularProgress, Dialog, DialogContent, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { useDiscussionForum } from '../../store/discussionforum.store'
import { Icons } from '../../utils/utilities'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Form, Formik } from 'formik'
import React, { useRef, useState } from 'react'
import api from '../../service/api'
import *  as Yup from 'yup'
import CustomWysiwyg from '../common/CustomWysiwyg'
import { discussionAttachmentUploader, onDiscussionFilePasteOrDrop } from '../../utils/custom-editor-utilities'

let filesList = [], editorRef

const filePasteOrDropHandler = async ( file, mime ) => {
    const urlDetails = await onDiscussionFilePasteOrDrop( file, mime )
    filesList.push( urlDetails.src )
    return urlDetails
}


const handleFileInput = async ( type ) => {
    const input = document.createElement( 'input' )

    input.setAttribute( 'type', 'file' )
    input.setAttribute( 'accept', type === 'image' ? 'image/*' : "video/*" )
    input.click()

    input.onchange = async () => {
        var file = input.files[0]
        // var fileName = `${Date.now()}_${file.name}`
        if ( type === 'image' && !file.type?.includes( 'image' ) ) {
            toast( "Invalid image format!" )
            return ''
        }
        if ( type === 'video' && !file.type?.includes( 'video' ) ) {
            toast( "Invalid video format!" )
            return ''
        }


        try {
            if ( editorRef.current ) {
                var url = await discussionAttachmentUploader( type, file )
                filesList.push( url )
                if ( url ) {
                    const range = editorRef.current.getSelection()
                    editorRef.current.insertEmbed( range.index, type, url )
                    editorRef.current.setSelection( range.index + 1 )
                    setTimeout( () => {
                        editorRef.current.focus()
                    }, 10 )
                }
            }

        } catch ( err ) {
            console.log( err )
        }
    }
}

const modules = {
    toolbar: {
        container: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ size: ['normal', 'small', 'large'] }],
            [{ align: [] }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'image', 'video'],
            ['clean'],
            ['code-block'],
        ],
        handlers: {
            image: async () => await handleFileInput( 'image' ),
            video: async () => await handleFileInput( 'video' )
        }
    }
}
function CommentBox( { commentBoxState, setCommentingTo, setCommentBoxState, commentingTo } ) {

    const DiscussionForumStore = useDiscussionForum()
    const { id: discussionId } = useParams()
    editorRef = useRef()

    const [posting, setPosting] = useState( false )

    const { palette } = useTheme()

    const initialValues = {
        comment_content: '',
        parent: commentingTo.parent
    }

    const validationSchema = Yup.object().shape( {} )



    const handleClose = ( reset ) => {
        reset()
        setCommentingTo( null )
        setCommentBoxState( false )
    }

    const deleteFileFromSpaces = async ( url ) => {
        try {
            await api.discussionForum.deleteFile( { url } )
            const fileUrlIndex = filesList.indexOf( url )
            if ( fileUrlIndex > -1 )
                filesList.splice( fileUrlIndex, 1 )
        } catch ( err ) {

        }
    }

    const handleCommentValueChange = ( val, setFieldValue, previousValue ) => {
        setFieldValue( 'comment_content', val )

        if ( val.length !== previousValue.length ) {
            for ( let i = 0; i < filesList.length; i++ ) {
                const url = filesList[i]
                if ( !val.includes( url ) ) {
                    deleteFileFromSpaces( decodeURIComponent( url ) )
                }
            }
        }
    }

    const submitComment = async ( values, { resetForm } ) => {
        setPosting( true )
        const val = values.comment_content
        for ( let i = 0; i < filesList.length; i++ ) {
            const url = filesList[i]
            if ( !val.includes( url ) ) {
                deleteFileFromSpaces( decodeURIComponent( url ) )
            }
        }
        if ( !val || val?.trim() === "" || val?.trim()?.replace( /\s/gi, "" ) === `<p></p>` || val?.trim()?.replace( /\s/gi, "" ) === `<p><br></p>` ) {
            toast( "Please write a comment before submitting" )
        } else {
            if ( await DiscussionForumStore.postComment( discussionId, values ) ) {
                resetForm()
                handleClose( resetForm )
            }
        }
        setPosting( false )
    }

    return (
        <Dialog open={commentBoxState} slotProps={{
            paper: { sx: { width: "85%", maxWidth: "750px" } }
        }}>
            <DialogContent sx={{ padding: 0 }} >
                <Box display="flex" height="100%" flexDirection="column">
                    <Formik initialValues={initialValues} onSubmit={submitComment} validationSchema={validationSchema} >
                        {( { values, setFieldValue, resetForm } ) => ( <Box>
                            <Box padding="10px 20px 0 20px" display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="subtitle2" fontSize="16px"><em>{commentingTo.name}</em> </Typography>
                                <Tooltip title="Cancel comment">
                                    <IconButton onClick={() => handleClose( resetForm )}>{Icons.default.CloseIcon}</IconButton>
                                </Tooltip>
                            </Box>
                            <Box margin="20px" marginTop="10px" borderRadius="5px" bgcolor={palette.form.formBg} >
                                <Form>
                                    <CustomWysiwyg filePasteOrDropHandler={filePasteOrDropHandler} height='150px' onChange={val => handleCommentValueChange( val, setFieldValue, values.comment_content )} setParentEditorRef={( refVal ) => editorRef.current = refVal?.current} value={values.comment_content} modules={modules} placeholder='Add your comment here...' />
                                    <Box marginTop="20px">
                                        <Button disabled={posting} size="large" type="submit" endIcon={posting ? <CircularProgress size={14} /> : Icons.default.Send} variant='contained' disableElevation sx={{ textTransform: "capitalize" }}>{posting ? "Posting..." : "Post comment"}</Button>
                                    </Box>
                                </Form>
                            </Box>
                        </Box> )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default CommentBox